<template>
  <div style="height: 100%;">
    <!--
        <Row style="min-height: 30px" type="flex" justify="center" align="center">
            <i-col :md="6" :sm="12" align="center" style="font-size: 14px;font-weight: bold">
                姓名：{{user.name}}
            </i-col>
            <i-col :md="6" :sm="12" align="center" style="font-size: 14px;font-weight: bold">
                性别：{{user.sex === '0'?'男':user.sex === '1'?'女':'-'}}
            </i-col>
            <i-col :md="6" :sm="12" align="center" style="font-size: 14px;font-weight: bold">
                出生日期：{{user.birthday ? moment(user.birthday).format('YYYY-MM-DD ') : ''}}
            </i-col>
            <i-col :md="6" :sm="12" align="center" style="font-size: 14px;font-weight: bold">
                联系电话：{{user.connectPhone}}
            </i-col>
        </Row>
        -->
    <Row style="height: 100%;" type="flex" id="imgTools">
      <Col style="overflow-y: auto;flex: 3;" :style="{ height: wHeight + 'px' }">
      <Card style="margin: 10px 0">
        <Row>
          <i-col :xxl="4" :md="6" :sm="12">
            <span style="font-size: 14px;font-weight: bold;border: solid 1px;margin-right: 5px">
              {{ user.isFirst ? '首诊' : '随诊' }} </span>{{ user.name }}{{ user.sex === '0' ? ' 男 ' : user.sex === '1' ? ' 女 ' : ' - ' }}{{
                user.age }}
          </i-col>
          <!--<i-col :xxl="4" :md="6" :sm="12">-->
          <!--性别：{{user.sex === '0'?'男':user.sex === '1'?'女':'-'}}-->
          <!--</i-col>-->
          <!--<i-col :xxl="4" :md="6" :sm="12">-->
          <!--年龄：{{user.age}}-->
          <!--</i-col>-->
          <i-col :xxl="4" :md="6" :sm="12">
            {{ user.height }}cm {{ user.weight }}kg
          </i-col>
          <i-col :xxl="4" :md="6" :sm="12">
            出生日期：{{ user.birthday ? moment(user.birthday).format('YYYY-MM-DD ') : '' }}
          </i-col>
          <i-col :xxl="4" :md="6" :sm="12">
            联系电话：{{ user.phone }}
          </i-col>
          <!--<i-col :xxl="4" :md="6" :sm="12">-->
          <!--体重： {{user.weight}}kg-->
          <!--</i-col>-->
          <i-col :xxl="4" :md="6" :sm="12">
            监护人：{{ user.guardianName }}
          </i-col>
          <i-col :xxl="4" :md="6" :sm="12">
            备用联系：{{ user.connectPhone }}
          </i-col>
          <i-col :xxl="4" :md="6" :sm="12">
            邮箱：{{ user.email }}
          </i-col>
          <i-col :xxl="4" :md="6" :sm="12">
            住址：{{ user.address }}
          </i-col>
        </Row>
      </Card>
      <!-- <Card style="margin: 10px 0">
        <Row v-if="user.isFirst && caseInfo != null">
          <Col span="24">
          <span class="bold-label">疾病名称：</span>
          <span v-for="item in caseInfo['发育障碍疾病']['answer']" v-if="caseInfo['发育障碍疾病'] && item != '无'"
            style="margin-right: 8px">{{ item }}</span>
          <span v-for="item in caseInfo['过敏性疾病']['answer']" v-if="caseInfo['过敏性疾病'] && item != '无'"
            style="margin-right: 8px">{{ item }}</span>
          <span v-for="item in caseInfo['免疫性疾病']['answer']" v-if="caseInfo['免疫性疾病'] && item != '无'"
            style="margin-right: 8px">{{ item }}</span>
          <span v-for="item in caseInfo['胃肠道疾病']['answer']" v-if="caseInfo['胃肠道疾病'] && item != '无'"
            style="margin-right: 8px">{{ item }}</span>
          <span v-for="item in caseInfo['精神神经性疾病']['answer']" v-if="caseInfo['精神神经性疾病'] && item != '无'"
            style="margin-right: 8px">{{ item }}</span>
          <span v-for="item in caseInfo['代谢性疾病']['answer']" v-if="caseInfo['代谢性疾病'] && item != '无'"
            style="margin-right: 8px">{{ item }}</span>
          </Col>
          <Col span="24">
          <span class="bold-label">病情描述：</span>
          患病
          <span v-if="caseInfo['本次患病多久了'] != null && caseInfo['本次患病多久了']['answer'] != ''"
            style="margin-right: 8px">{{ caseInfo['本次患病多久了']['answer'] }}</span>
          <span v-if="caseInfo['本次咨询前是否到医院就诊过'] != null && caseInfo['本次咨询前是否到医院就诊过']['answer'] != '' &&
            caseInfo['本次咨询前是否到医院就诊过']['answer'] != '否'"
            style="margin-right: 8px">{{ caseInfo['本次咨询前是否到医院就诊过']['answer'] }}</span>
          <span v-else-if="caseInfo['本次咨询前是否到医院就诊过'] != null && (caseInfo['本次咨询前是否到医院就诊过']['answer'] === '' ||
            caseInfo['本次咨询前是否到医院就诊过']['answer'] === '否')" style="margin-right: 8px">未到医院就诊过</span>
          <span v-if="caseInfo['病情补充说明'] != null && caseInfo['病情补充说明']['answer'] != ''"
            style="margin-right: 8px">{{ caseInfo['病情补充说明']['answer'] }}</span>
          <span v-if="caseInfo['有哪些胃肠道症状'] != null">
            <span v-for="item in caseInfo['有哪些胃肠道症状']['answer']" v-if="item != '无'"
              style="margin-right: 8px">{{ item }}</span>
          </span>
          <span v-if="caseInfo['进食量'] != null && caseInfo['进食量']['answer'] != ''"
            style="margin-right: 8px">{{ caseInfo['进食量']['answer'] }}进食</span>
          <span v-if="caseInfo['大便性状'] != null && caseInfo['大便性状']['answer'] != ''"
            style="margin-right: 8px">大便{{ caseInfo['大便性状']['answer'] }}</span>
          <span v-if="caseInfo.自我评价 != null && caseInfo.自我评价.answer != null">
            <span v-for="item in Object.keys(caseInfo.自我评价.answer)" v-if="item != ''" style="margin-right: 8px">
              {{ item }}：{{ caseInfo.自我评价.answer[item].rate }}分</span>
          </span>
          </Col>
          <Col span="24">
          <span class="bold-label">症状：</span>
          <span v-if="caseInfo['请输入症状'] != null && caseInfo['请输入症状']['answer'] != ''"
            style="margin-right: 8px">{{ caseInfo['请输入症状']['answer'] }}</span>
          <span v-if="caseInfo['困扰你的其它症状'] != null && caseInfo['困扰你的其它症状']['answer'] != ''"
            style="margin-right: 8px">{{ caseInfo['困扰你的其它症状']['answer'] }}</span>
          </Col>
          <Col span="24">
          <span class="bold-label">主要诉求：</span>
          <span v-if="caseInfo['请描述主要诉求，重点希望哪些方面得到改善'] != null && caseInfo['请描述主要诉求，重点希望哪些方面得到改善']['answer'] != ''"
            style="margin-right: 8px">{{ caseInfo['请描述主要诉求，重点希望哪些方面得到改善']['answer'] }}</span>
          </Col>
          <Col span="24">
          <span class="bold-label">目前治疗：</span>
          <span v-if="caseInfo['目前治疗中的饮食干预'] != null">
            禁食
            <span v-if="caseInfo['目前治疗中的饮食干预']['answer'] != null && caseInfo['目前治疗中的饮食干预']['answer'].length > 0">
              <span v-for="item in caseInfo['目前治疗中的饮食干预']['answer']" v-if="item != null && item != '其它'"
                style="margin-right: 8px">{{ item }}</span>
            </span>
            <span v-else-if="caseInfo['目前治疗中的饮食干预']['answer'] != '其它'" style="margin-right: 8px">
              {{ caseInfo['目前治疗中的饮食干预']['answer'] }}</span>
          </span>
          <span v-if="caseInfo['目前治疗中的药物'] != null">
            使用
            <span v-if="caseInfo['目前治疗中的药物']['answer'] != null && caseInfo['目前治疗中的药物']['answer'].length > 0">
              <span v-for="item in caseInfo['目前治疗中的药物']['answer']" v-if="item != null && item != '无' && item != '其它'"
                style="margin-right: 8px">{{ item }}</span>
            </span>
            <span v-else-if="caseInfo['目前治疗中的药物']['answer'] != '其它'" style="margin-right: 8px">
              {{ caseInfo['目前治疗中的药物']['answer'] }}</span>
          </span>
          <span v-if="caseInfo['目前治疗中的营养素'] != null">
            使用
            <span v-if="caseInfo['目前治疗中的营养素']['answer'] != null && caseInfo['目前治疗中的营养素']['answer'].length > 0">
              <span v-for="item in caseInfo['目前治疗中的营养素']['answer']" v-if="item != null && item != '无' && item != '其它'"
                style="margin-right: 8px">{{ item }}</span>
            </span>
            <span v-else-if="caseInfo['目前治疗中的营养素']['answer'] != '其它'" style="margin-right: 8px">
              {{ caseInfo['目前治疗中的营养素']['answer'] }}</span>
          </span>
          <span v-if="caseInfo['目前治疗中的药物及营养素'] != null">
            使用
            <span v-if="caseInfo['目前治疗中的药物及营养素']['answer'] != null && caseInfo['目前治疗中的药物及营养素']['answer'].length > 0">
              <span v-for="item in caseInfo['目前治疗中的药物及营养素']['answer']" v-if="item != null && item != '无' && item != '其它'"
                style="margin-right: 8px">{{ item }}</span>
            </span>
            <span v-else-if="caseInfo['目前治疗中的药物及营养素']['answer'] != '其它'" style="margin-right: 8px">
              {{ caseInfo['目前治疗中的药物及营养素']['answer'] }}</span>
          </span>
          <span v-if="caseInfo['患者当前使用的药物'] != null && caseInfo['患者当前使用的药物']['answer'] != '无'"
            style="margin-right: 8px">{{ caseInfo['患者当前使用的药物']['answer'] }}</span>
          </Col>
          <Col span="24">
          <span class="bold-label">辅助检测及检查：</span>
          <div class="group-row">
            <div v-if="caseInfo['病情相关的检查结果'] != null">
              <div v-for="(item, index) in caseInfo['病情相关的检查结果'].answer">
                <img :data-original='`food/${item}`' :src="`food/${item}`" style="height: 20px;width: 20px;margin: 5px 10px">
              </div>
            </div>
            <div v-if="caseInfo['处方/药盒照片'] != null">
              <div v-for="(item, index) in caseInfo['处方/药盒照片'].answer">
                <img :data-original='`food/${item}`' :src="`food/${item}`" style="height: 20px;width: 20px;margin: 5px 10px">
              </div>
            </div>
          </div>
          </Col>
          <Col span="24">
          <span class="bold-label">既往史：</span>
          <span v-if="caseInfo['既往史'] != null">
            <span v-for="item in caseInfo['既往史']['answer']" v-if="item != '无'" style="margin-right: 8px">{{ item }}</span>
          </span>
          </Col>
          <Col span="24">
          <span class="bold-label">过敏史：</span>
          <span v-if="caseInfo['药物过敏'] != null && caseInfo['药物过敏']['answer'] != '无'"
            style="margin-right: 8px">{{ caseInfo['药物过敏']['answer'] }}</span>
          <span v-if="caseInfo['过敏性疾病及症状'] != null">
            <span v-for="item in caseInfo['过敏性疾病及症状']['answer']" v-if="item != '无' && item != null"
              style="margin-right: 8px">{{ item }}</span>
          </span>
          </Col>
          <Col span="24">
          <span class="bold-label">附件：</span>
          <div v-if="caseInfo['附件'] != null">
            <div v-for="(item, index) in caseInfo['附件'].answer">
              <img :data-original='`food/${item}`' :src="`food/${item}`" style="height: 20px;width: 20px;margin: 5px 10px">
            </div>
          </div>
          </Col>
        </Row>
        <Row v-if="!user.isFirst && followCaseInfo != null">
          <Col span="24">
          <span class="bold-label">近期病情变化：</span>
          <span v-if="followCaseInfo['近期病情变化'] != null && followCaseInfo['近期病情变化']['answer'] != ''"
            style="margin-right: 8px">{{ followCaseInfo['近期病情变化']['answer'] }}</span>
          </Col>
          <Col span="24">
          <span class="bold-label">饮食干预是否严格：</span>
          <span v-if="followCaseInfo['饮食干预是否严格'] != null && followCaseInfo['饮食干预是否严格']['answer'] != ''"
            style="margin-right: 8px">饮食干预{{ followCaseInfo['饮食干预是否严格']['answer'] }}</span>
          </Col>
          <Col span="24">
          <span class="bold-label">使用的营养素/药品：</span>
          <span v-if="followCaseInfo['使用的营养素/药品'] != null && followCaseInfo['使用的营养素/药品']['answer'] != ''"
            style="margin-right: 8px">{{ followCaseInfo['使用的营养素/药品']['answer'] }}</span>
          </Col>
          <Col span="24">
          <span class="bold-label">辅助检测及检查：</span>
          <div class="group-row" v-if="followCaseInfo['如果有新的检查结果，请上传图片'] != null">
            <div v-for="(item, index) in followCaseInfo['如果有新的检查结果，请上传图片'].answer">
              <img :data-original='`food/${item}`' :src="`food/${item}`" style="height: 20px;width: 20px;margin: 5px 10px">
            </div>
          </div>
          </Col>
          <Col span="24">
          <span class="bold-label">病情描述：</span>
          <span v-if="followCaseInfo['有哪些胃肠道症状'] != null">
            <span v-for="item in followCaseInfo['有哪些胃肠道症状']['answer']" v-if="item != '无'"
              style="margin-right: 8px">{{ item }}</span>
          </span>
          <span v-if="followCaseInfo['进食量'] != null && followCaseInfo['进食量']['answer'] != ''"
            style="margin-right: 8px">{{ followCaseInfo['进食量']['answer'] }}进食</span>
          <span v-if="followCaseInfo['大便性状'] != null && followCaseInfo['大便性状']['answer'] != ''"
            style="margin-right: 8px">大便{{ followCaseInfo['大便性状']['answer'] }}</span>
          <span v-if="followCaseInfo['自我评价'] != null && followCaseInfo.自我评价.answer != null">
            <span v-for="item in Object.keys(followCaseInfo.自我评价.answer)" v-if="item != ''" style="margin-right: 8px">
              {{ item }}：{{ followCaseInfo.自我评价.answer[item].rate }}分</span>
          </span>
          </Col>
          <Col span="24">
          <span class="bold-label">本次咨询需要解决的问题：</span>
          <span v-if="followCaseInfo['本次咨询需要解决的问题'] != null && followCaseInfo['本次咨询需要解决的问题']['answer'] != ''"
            style="margin-right: 8px">
            {{ followCaseInfo['本次咨询需要解决的问题']['answer'] }}</span>
          </Col>
        </Row>
      </Card> -->
      <Collapse v-model="panelValue">
        <Card style="margin: 10px 0">
          <Row>
            <Form :label-width="80">
              <i-col :md="12" :sm="24">
                <FormItem label="疾病名称：" style="margin-bottom: 0px">
                  <Select v-model="prescription.diagnose" filterable multiple allow-create>
                    <Option v-for="(item, index) in diagnoseItems" :value="item" :key="index">{{ item }}</Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col :md="12" :sm="24">
                <FormItem label="其它：" style="margin-bottom: 0px">
                  <Input v-model="prescription.otherDiagnose" placeholder="请输入" />
                </FormItem>
              </i-col>
              <i-col :md="24" style="margin-top: 5px">
                <FormItem label="医生记录：" style="margin-bottom: 0px">
                  <Input v-model="prescription.impression" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }"
                    placeholder="请输入..." />
                </FormItem>
              </i-col>
            </Form>
          </Row>
        </Card>
        <Card style="margin: 10px 0">
          <Row>
            <Form :label-width="80">
              <i-col :md="12" :sm="24">
                <FormItem label="检测检查：" style="margin-bottom: 0px">
                  <Select v-model="prescription.examination" ref="setSelect" filterable multiple allow-create
                    @keyup.enter.native="testCreate">
                    <Option-group label="常规检查">
                      <Option v-for="item in testItems" :value="item" :key="item">{{ item }}</Option>
                    </Option-group>
                    <Option-group label="血液化验检测">
                      <Option v-for="item in bloodTestItems" :value="item" :key="item">{{ item }}</Option>
                    </Option-group>
                    <Option-group label="检查">
                      <Option v-for="item in examinationItems" :value="item" :key="item">{{ item }}</Option>
                    </Option-group>
                  </Select>
                </FormItem>
              </i-col>
              <i-col :md="12" :sm="24">
                <FormItem label="其它检查：" style="margin-bottom: 0px">
                  <Input v-model="prescription.otherExamination" placeholder="请输入检测检查项目" />
                </FormItem>
              </i-col>
            </Form>
          </Row>
        </Card>
        <Card>
          <Row>
            <Form :label-width="100">
              <FormItem label="饮食原则建议：" style="margin-bottom: 0px">
                <Select transfer multiple v-model.sync="prescription.dietGuidelines" placeholder="请选择">
                  <Option v-for="item in dietGuidelinesAllList" :value="item.id" :key="item.id">
                    {{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Form>
          </Row>
          <Row>
            <Form :label-width="100" style="margin-top: 10px">
              <FormItem label="一周食谱建议：" style="margin-bottom: 0px">
                <Button type="info" @click="goDietPlanSetting()" v-if="userDietPlan != null">+已设置，去修改</Button>
                <Button type="info" @click="goDietPlanSetting()" v-else>+去设置</Button>
              </FormItem>
            </Form>
          </Row>
          <Collapse v-model="medicalPanel" style="margin-top: 10px">
            <Panel>
              营养目标建议
              <p slot="content">
                <Row type="flex" style="padding: 0 20px" justify="center" align="bottom">
                  <Col span="24">
                  <Form :label-width="100">
                    <Row>
                      <Col span="10">
                      <FormItem label="患者年龄：">
                        <input v-model="nutritionalGoalSearch.age" placeholder="请输入..." style="width: 100px" />
                      </FormItem>
                      </Col>
                      <Col span="10">
                      <FormItem label="患者性别：">
                        <Select transfer v-model="nutritionalGoalSearch.sex" placeholder="请选择">
                          <Option value="0">男性</Option>
                          <Option value="1">女性</Option>
                        </Select>
                      </FormItem>
                      </Col>
                    </Row>
                    <Row>
                      <Col span="10">
                      <FormItem label="患者身高：">
                        <input v-model="nutritionalGoalSearch.height" placeholder="请输入..." style="width: 100px" />&nbsp;cm
                      </FormItem>
                      </Col>

                      <Col span="10">
                      <FormItem label="患者体重：">
                        <input v-model="nutritionalGoalSearch.weight" placeholder="请输入..." style="width: 100px" />&nbsp;kg
                      </FormItem>
                      </Col>
                      <Col span="4">
                      <Button type="info" long @click="findAllNutritionalGoal">查询</Button>
                      </Col>
                    </Row>
                  </Form>
                  <div style="padding-bottom: 20px;">
                    <Card>
                      <p slot="title">营养目标</p>
                      <div
                        v-if="nutritionalGoalSearch.age != null && nutritionalGoalSearch.sex != null &&
                          nutritionalGoalSearch.weight != null && nutritionalGoalSearch.height != null"
                        style="color: #ff3d1f">
                        <!--男热量计算公式： （66.4230 + 13.7516 * 体重（千克）+ 5.0033 * 身高（厘米） + 6.7750 * 年龄） * 1.375-->
                        <span v-if="nutritionalGoalSearch.sex === '0'">你每日需摄入的热量是{{ (66.4230 + 13.7516 *
                          nutritionalGoalSearch.weight + 5.0033 * nutritionalGoalSearch.height + 6.7750 *
                          nutritionalGoalSearch.age) * 1.375 }}千卡</span>
                        <!--男热量计算公式： （655.0955 + 9.6534 * 体重（千克）+ 1.8496 * 身高（厘米） + 4.6756 * 年龄） * 1.375-->
                        <span v-if="nutritionalGoalSearch.sex === '1'">你每日需摄入的热量是{{ (655.0955 + 9.6534 *
                          nutritionalGoalSearch.weight + 1.8496 * nutritionalGoalSearch.height + 4.6756 *
                          nutritionalGoalSearch.age) * 1.375 }}千卡</span>
                      </div>
                      <span v-else>身高/体重/年龄/性别数据不全</span>
                      <Table v-if="nutritionalGoal != null" stripe max-height="500" :columns="nutritionalGoalInfoColumns"
                        :data="nutritionalGoal.infoList">
                        <template slot-scope="{ row, index }" slot="value">
                          <Input v-model="nutritionalGoal.infoList[index].value" style="top: 0;" placeholder="请输入">
                          <span slot="append">{{ row.nutritionType.unit }}</span>
                          </Input>
                        </template>
                      </Table>
                    </Card>
                  </div>
                  </Col>
                </Row>
              </p>
            </Panel>
            <Panel>
              营养药品建议
              <p slot="content">
                <Card style="margin: 10px 0" :key="item.medicalId" v-for="(item, i) in prescription.content">
                  <h3>{{ i + 1 + '.' + item.medicine.name }}</h3>
                  <p v-if="item.num > 0">数量：{{ item.num }}盒</p>
                  <div style="display: flex;flex-direction: row">
                    <p>用法用量：{{ item.channel ? item.channel : '' }} </p>
                    <p>&nbsp;&nbsp;{{ item.once.num ? item.once.num : 0 }}</p>
                    <p>{{ item.once.type ? item.once.type : '' }}</p>
                    <p>&nbsp;&nbsp;{{ item.frequency ? item.frequency : '' }} </p>
                    <p>&nbsp;&nbsp;使用{{ item.dayNum ? item.dayNum : 0 }}天 </p>
                  </div>
                  <p v-if="item.content != null && item.content !== ''">补充说明：{{ item.content }}</p>
                  <Row type="flex" justify="end">
                    <Button type="success" style="margin: 0 10px"
                      @click.stop="medicineIndex = i, medicineEditModal = true">
                      编辑
                    </Button>
                    <Button type="error" style="margin: 0 10px" @click.stop="delMedicine(i)">删除</Button>
                  </Row>
                </Card>
                <Button type="info" style="margin-top: 10px" long @click.stop="openMedicineModal">+继续添加药品/营养素</Button>
              </p>
            </Panel>
            <Panel>
              其他注意事项
              <p slot="content">
                <Input v-model="prescription.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }"
                  placeholder="请输入..." />
              </p>
            </Panel>
            <Panel>
              下次随诊设置
              <p slot="content">
              <Form :label-width="120">
                <FormItem label="是否下次随诊：">
                  <i-switch @on-change="followDiagnose">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem label="随诊时间：" v-if="prescription.followDiagnose">
                  <DatePicker type="datetime" placeholder="请选择..." style="width: 100%" v-model="prescription.followTime">
                  </DatePicker>
                </FormItem>
                <FormItem label="问卷提醒时间：" v-if="prescription.followDiagnose">
                  <Select v-model="prescription.remindTime">
                    <Option value="1">1天前</Option>
                    <Option value="2">2天前</Option>
                    <Option value="3">3天前</Option>
                    <Option value="5">5天前</Option>
                    <Option value="7">1周前</Option>
                  </Select>
                </FormItem>
              </Form>
              </p>
            </Panel>
          </Collapse>
        </Card>
        <Col span="24" style="display: flex;flex-direction: row;justify-content: flex-end">
        <Button type="info" icon="ios-add" style="margin: 10px 10px" @click.stop="goSave">保存</Button>
        </Col>
      </Collapse>
      </Col>
      <Col style="overflow-y: auto;height: 100%;flex: 2;width: 100%">
      <medical-history></medical-history>
      </Col>
      <!--药品-->
      <Modal v-if="medicineVo !== null" v-model="medicineModal" title="调整用法用量">
        <div style="display: flex;">
          <p style="line-height: 32px;width: 100px;text-align: right;padding-right: 12px">选择药品/营养素：</p>
          <Select v-model="medicineVo.medicalName" style="width: 50%" filterable @on-change="medicineChange">
            <Option :value="index" :key="medicine.id" v-for="(medicine, index) in medicineList">{{ medicine.name }}</Option>
          </Select>
        </div>
        <Card style="margin: 5px 20px;" v-if="medicineVo.medicine != null">{{ medicineVo.medicine.description }}</Card>
        <Form :label-width="100">
          <FormItem style="margin-bottom: 10px" label="单次药量：">
            <Input v-model="medicineVo.once.num" style="width: 50%" />
            <!--<Input v-model="medicineVo.once.type" placeholder="用药单位" style="width: 50%"/>-->
            <Select v-model="medicineVo.once.type" style="width: 50%">
              <Option value="mg/次">mg/次</Option>
              <Option value="粒/次">粒/次</Option>
              <Option value="ml/次">ml/次</Option>
            </Select>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="给药频率：">
            <!--<Input v-model="medicineVo.frequency" placeholder="给药频率" style="width: 50%"/>-->
            <Select v-model="medicineVo.frequency">
              <Option value="1次/天">1次/天</Option>
              <Option value="2次/天">2次/天</Option>
              <Option value="3次/天">3次/天</Option>
              <Option value="大于3次/天">大于3次/天</Option>
              <Option value="1次/3天">1次/3天</Option>
              <Option value="1次/周">1次/周</Option>
              <Option value="1次/月">1次/月</Option>
            </Select>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="给药途径：">
            <!--<Input v-model="medicineVo.channel" placeholder="给药途径" style="width: 50%"/>-->
            <Select v-model="medicineVo.channel">
              <Option value="口服">口服</Option>
              <Option value="静脉注射">静脉注射</Option>
              <Option value="皮下注射">皮下注射</Option>
              <Option value="肌肉注射">肌肉注射</Option>
              <Option value="舌下含服">舌下含服</Option>
            </Select>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="给药天数：">
            <InputNumber v-model="medicineVo.dayNum" :min="0" style="width: 50%" />
            <span style="padding-left: 20px">天</span>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="开药数：">
            <InputNumber v-model="medicineVo.num" :min="0" style="width: 50%" />
            <span style="padding-left: 20px">盒</span>
          </FormItem>
          <div>
            <p style="margin-bottom: 10px">补充说明（选填）</p>
            <Input v-model="medicineVo.content" type="textarea" :autosize="{ minRows: 3, maxRows: 10 }"
              placeholder="请输入..." />
          </div>
        </Form>
        <div slot="footer">
          <Button type="text" size="large" @click.stop="cancelMedical">取消</Button>
          <Button type="primary" size="large" @click.stop="addMedical">确定</Button>
        </div>
      </Modal>
      <Modal v-if="prescription.content[medicineIndex] != null" v-model="medicineEditModal" title="调整用法用量">
        <h3 style="margin-bottom: 10px;text-align: center">{{ prescription.content[medicineIndex].medicine.name }}</h3>
        <Card style="margin: 5px 20px;">{{ prescription.content[medicineIndex].medicine.indication }}</Card>
        <Form :label-width="100">
          <FormItem style="margin-bottom: 10px" label="单次药量：">
            <Input v-model="prescription.content[medicineIndex].once.num" style="width: 50%" />
            <Select v-model="prescription.content[medicineIndex].once.type" style="width: 50%">
              <Option value="mg/次">mg/次</Option>
              <Option value="粒/次">粒/次</Option>
              <Option value="ml/次">ml/次</Option>
            </Select>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="给药频率：">
            <!--<Input v-model="prescription.content[medicineIndex].frequency" placeholder="给药频率" style="width: 50%"/>-->
            <Select v-model="medicineVo.frequency">
              <Option value="1次/天">1次/天</Option>
              <Option value="2次/天">2次/天</Option>
              <Option value="3次/天">3次/天</Option>
              <Option value="大于3次/天">大于3次/天</Option>
              <Option value="1次/3天">1次/3天</Option>
              <Option value="1次/周">1次/周</Option>
              <Option value="1次/月">1次/月</Option>
            </Select>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="给药途径：">
            <Select v-model="medicineVo.channel">
              <Option value="口服">口服</Option>
              <Option value="静脉注射">静脉注射</Option>
              <Option value="皮下注射">皮下注射</Option>
              <Option value="肌肉注射">肌肉注射</Option>
              <Option value="舌下含服">舌下含服</Option>
            </Select>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="给药天数：">
            <InputNumber v-model="prescription.content[medicineIndex].dayNum" :min="0" style="width: 50%" />
            <span style="padding-left: 20px">天</span>
          </FormItem>
          <FormItem style="margin-bottom: 10px" label="开药数：">
            <InputNumber v-model="prescription.content[medicineIndex].num" :min="0" style="width: 50%" />
            <span style="padding-left: 20px">盒</span>
          </FormItem>
          <div>
            <p style="margin-bottom: 10px">补充说明（选填）</p>
            <Input v-model="prescription.content[medicineIndex].content" type="textarea"
              :autosize="{ minRows: 3, maxRows: 10 }" placeholder="请输入..." />
          </div>
        </Form>
        <div slot="footer">
          <!--<Button type="text" size="large" @click.stop="medicineModal = false" >取消</Button>-->
          <Button type="primary" size="large" @click.stop="medicineEditModal = false">确定</Button>
        </div>
      </Modal>
      <diet-plan-setting :diet-plan-dialog="dietPlanDialog" ref="setPlan" :user="user"
        @closeDialog="getDietPlan"></diet-plan-setting>
    </Row>
  </div>
</template>
<script>
import Moment from 'moment'
import dietPlanSetting from './dietPlanSetting.vue'
import medicalHistory from './medical_history.vue'
import Viewer from 'viewerjs';
import ICol from "../../../node_modules/iview/src/components/grid/col.vue";
export default {
  name: "",
  components: {
    Moment,
    ICol,
    dietPlanSetting,
    medicalHistory
  },
  props: {
  },
  data() {
    return {
      wHeight: window.innerHeight - 50,
      user: this.$store.state.currentPatient,
      moment: Moment,
      panelValue: [1, 2, 3],
      medicalPanel: [],
      medicineModal: false,
      medicineVo: null,
      medicineList: [],
      medicineIndex: -1,
      medicineEditModal: false,
      testItems: [
        '头发重金属与微量元素检测',
        '大便宏基因组检测',
        '尿有机酸检测',
        '食物IgG抗体检测'
      ],
      bloodTestItems: [
        '抽血查血常规',
        '免疫球蛋白',
        '肝全肾全脂全',
        '肌酸激酶',
        '叶酸',
        '维生素B12',
        '维生素D',
        'IgE',
        '过敏原筛查'
      ],
      examinationItems: [
        '24小时或过夜脑电图',
        '头颅核磁'
      ],
      testItem: '', //检测项目
      otherTestItem: '', // 其它检测检查项目
      diagnoseItems: [], // 诊断选项
      nutritionalGoalSearch: {
        age: null,
        sex: null,
        weight: null,
        height: null
      },
      nutritionalGoal: null, //对应的营养目标
      nutritionalGoalInfo: [], //所有营养物质
      nutritionalGoalInfoColumns: [
        {
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '营养物质',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            let item = params.row
            return h("span", item.nutritionType.name)
          },
        },
        {
          title: '含量',
          ellipsis: true,
          tooltip: true,
          slot: 'value'
        },
      ],//营养物质表头
      prescription: {
        diagnose: [],
        otherDiagnose: '',
        dietGuidelines: [],
        dietGuidelinesDetail: [],
        dietPlanId: '',
        nutritionalGoalId: '',
        content: [],
        medicineUsageId: '',
        advice: null,
        followDiagnose: false,
        followTime: null,
        remindTime: '3',
        examination: null,
        otherExamination: null,
        impression: '', // 体检印象
        remark: '' // 其它注意事项
      },
      nutritionalGoalId: null,
      dietPlanId: null,
      dietGuidelinesAllList: [],//所有原则
      dietPlanDialog: false,
      userDietPlan: null,
      caseInfo: null,
      followCaseInfo: null,
      firstQuestions: null,
      followQuestions: null,
      editable: false,
      caseData: null,
      otherCaseData: null,
      userDiagnose: null, // 患者诊断
      isAutism: false // 患者是否孤独症为自闭症
    }
  },
  watch: {
    nutritionalGoalId() {
      if (this.nutritionalGoalId != null && this.nutritionalGoalId !== '' &&
        this.dietPlanId != null && this.dietPlanId !== '') {
        this.savePrescription()
      }
    },
    dietPlanId() {
      if (this.nutritionalGoalId != null && this.nutritionalGoalId !== '' &&
        this.dietPlanId != null && this.dietPlanId !== '') {
        this.savePrescription()
      }
    }
  },
  created() {
    this.$store.commit('setCurrentPatient', JSON.parse(sessionStorage.getItem('currentPatient')))
    this.user = this.$store.state.currentPatient
    this.$store.commit('setCurrentPatient', JSON.parse(sessionStorage.getItem('currentPatient')))
    if (this.user != null) {
      this.user['age'] = this.getAgeByBirthday(this.user.birthday)
      this.isAutism = this.user.isAutism
      this.nutritionalGoalSearch.age = this.user.age
      this.nutritionalGoalSearch.sex = this.user.sex
      this.nutritionalGoalSearch.height = this.user.height
      this.nutritionalGoalSearch.weight = this.user.weight
    }
    this.findAllDietGuidelinesList()
    this.findAllMedicine()
    this.getUserCase()
    this.getLatestCase()
    this.findAllNutritionalGoal()
  },
  mounted() {
    this.user = this.$store.state.currentPatient
  },
  methods: {
    checkUser() {
      this.user = this.$store.state.currentPatient
      if (this.user == null || this.user.id == null) {
        this.$Notice.error({ title: '请重新登录' })
        this.$router.push('/')
        return
      }
    },
    // 获取最近一条首诊病历
    getUserCase() {
      this.checkUser()
      this.infoLoading = true
      this.$http.post('medicalRecord/getResult', {
        userId: this.user.id,
        isFirst: true,
        pageSize: 1
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          if (msg.data.list != null && msg.data.list.length > 0) {
            // 如果是首诊，用caseData存储首诊的caseData，如果是随诊，用otherCaseData存储首诊的caseData
            if (this.user.isFirst) {
              this.caseData = msg.data.list[0]
              this.caseInfo = JSON.parse(this.caseData.result)
            } else {
              this.otherCaseData = msg.data.list[0]
              this.caseInfo = JSON.parse(this.otherCaseData.result)
            }
            this.getfirstQuestion()
          }
        } else {
          this.$Notice.error({ title: '病历查询失败', desc: msg.message });
        }
      }, function (res) {
        this.infoLoading = false
        this.myError(res.body)
      })
    },
    // 获取最近一条随诊病历
    getLatestCase() {
      this.checkUser()
      this.infoLoading = true
      this.$http.post('medicalRecord/getResult', {
        userId: this.user.id,
        isFirst: false,
        pageSize: 1
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          if (msg.data.list != null && msg.data.list.length > 0) {
            // 如果是首诊，用otherCaseData存储随诊的caseData，如果是随诊，用caseData存储随诊的caseData
            if (this.user.isFirst) {
              this.otherCaseData = msg.data.list[0]
              this.followCaseInfo = JSON.parse(this.otherCaseData.result)
            } else {
              this.caseData = msg.data.list[0]
              this.followCaseInfo = JSON.parse(this.caseData.result)
            }
            this.getFollowQuestion()
            console.log('followCaseInfo', this.followCaseInfo)
            console.log('caseInfo', this.caseInfo)
          }
        } else {
          this.$Notice.error({ title: '病历查询失败', desc: msg.message });
        }
      }, function (res) {
        this.infoLoading = false
        this.myError(res.body)
      })
    },
    initImageTools() {
      //初始化 viewerjs
      setTimeout(() => {
        this.ViewerDom = document.getElementById('imgTools');
        const viewer = new Viewer(this.ViewerDom, {
          url: "data-original",
          show: function () {
            viewer.update()
          }
        });
      }, 300)
    },
    // 获取首诊问题
    getfirstQuestion() {
      this.$http.get('medicalRecord/firstQuestion?part=0').then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.firstQuestions = msg.data
          this.bindAnswerToQuestion(true)
          setTimeout(() => {
            this.initImageTools()
          }, 200)
        } else {
          this.$Notice.error({ title: '病历查询失败', desc: msg.message });
        }
      }, function (res) {
        this.infoLoading = false
        this.myError(res.body)
      })
    },
    // 获取随诊问题
    getFollowQuestion() {
      this.$http.get('medicalRecord/followQuestion').then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.followQuestions = msg.data
          this.bindAnswerToQuestion(false)
          setTimeout(() => {
            this.initImageTools()
          }, 200)
        } else {
          this.$Notice.error({ title: '病历查询失败', desc: msg.message });
        }
      }, function (res) {
        this.infoLoading = false
        this.myError(res.body)
      })
    },
    // 把病历答案绑定回问题
    bindAnswerToQuestion(isFirst) {
      if (isFirst) {
        this.diagnoseItems = []
        this.firstQuestions.map((item, i) => {
          item.questions.map(question => {
            // 获取首诊第一模块各题的选项，排除选项无
            if (i === 0) {
              question.choice.map(choice => {
                if (choice !== '无' && choice !== null && choice !== '其它') {
                  this.diagnoseItems.push(choice)
                }
              })
            }
            if (this.caseInfo[question.question] != null) {
              let temp = question
              question['answer'] = JSON.parse(JSON.stringify(this.caseInfo[question.question]))
              this.caseInfo[question.question] = temp
              // 如果有选项，则看答案中是否有不在选项中的其它自定义输入内容
              if (question.choice != null && question.choice.length > 0) {
                if (Array.isArray(question.answer)) {
                  question.answer.map(ans => {
                    if (question.choice.indexOf(ans) < 0) {
                      question.choice.push(ans)
                    }
                  })
                } else {
                  if (question.choice.indexOf(question.answer) < 0) {
                    question.choice.push(question.answer)
                  }
                }
              }
            }
          })
        })
      } else {
        this.followQuestions.map(item => {
          item.questions.map(question => {
            if (this.followCaseInfo[question.question] != null) {
              let temp = question
              question['answer'] = JSON.parse(JSON.stringify(this.followCaseInfo[question.question]))
              this.followCaseInfo[question.question] = temp
              // 如果有选项，则看答案中是否有不在选项中的其它自定义输入内容
              if (question.choice != null && question.choice.length > 0) {
                if (Array.isArray(question.answer)) {
                  question.answer.map(ans => {
                    if (question.choice.indexOf(ans) < 0) {
                      question.choice.push(ans)
                    }
                  })
                } else {
                  if (question.choice.indexOf(question.answer) < 0) {
                    question.choice.push(question.answer)
                  }
                }
              }
            }
          })
        })
      }
    },
    // 是否需要随诊
    followDiagnose(value) {
      this.prescription.followDiagnose = value
    },
    // 根据选择的饮食原则，设置一周食谱
    goDietPlanSetting() {
      if (this.prescription.dietGuidelines != null && this.prescription.dietGuidelines.length > 0) {
        this.dietPlanDialog = true
        this.$refs.setPlan.getFoodsByDietGuidline(this.prescription.dietGuidelines)
        this.$refs.setPlan.findAllDietPlan()
      } else {
        this.$Notice.warning({ title: '请先设置饮食原则' })
      }
    },
    testCreate(val) {
      console.log(val)
    },
    // 打开添加药品/营养素的弹窗
    openMedicineModal() {
      this.medicineModal = true
      this.medicineVo = {
        medicalId: null,
        medicine: {},
        medicalName: '',
        specs: '25mg*10s*3板',
        once: {
          num: null,
          type: 'mg/次'
        },
        frequency: '每日一次',
        channel: '口服',
        dayNum: null,
        num: null,
        content: null,
      }
    },
    medicineChange(index) {
      this.medicineVo.medicine = this.medicineList[index]
      this.medicineVo.once.num = this.medicineList[index].singleDose
      this.medicineVo.once.unit = this.medicineList[index].unit
      this.medicineVo.frequency = this.medicineList[index].dosingFrequency
      this.medicineVo.channel = this.medicineList[index].routeOfAdministration
    },
    addMedical() {
      if (this.medicineVo.medicine == null || this.medicineVo.medicine.id == null) {
        this.$Notice.warning({ title: '请选择药品/营养素' })
        return
      }
      this.medicineModal = false
      this.prescription.content.push(this.medicineVo)
    },
    delMedicine(index) {
      this.prescription.content.splice(index, 1)
    },
    cancelMedical() {
      this.medicineModal = false
    },
    // 获取药品
    findAllMedicine() {
      this.$http.post('medicine/list', {
        isDeleted: false,
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.medicineList = msg.data.list
        } else {
          if (msg.code === '201' || msg.message === '未登录') {
            this.$Notice.error({ title: '登录过期，请重新登录' });
            this.$router.push('/')
            console.log('提示重新登录')
          } else {
            this.$Notice.error({ title: '药品查询失败', desc: msg.message });
          }
        }
      }, function (res) {
        this.myError(res.body)
      })
    },
    // 获取营养目标
    findAllNutritionalGoal() {
      this.$http.post('nutritionalGoal/listRequirement', {
        age: this.nutritionalGoalSearch.age ? this.nutritionalGoalSearch.age : null,
        sex: this.nutritionalGoalSearch.sex == 0 ? 'm' : 'f'
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.nutritionalGoal = msg.data
          if (msg.data.length === 1) {
            this.nutritionalGoal = msg.data[0]
          }
        } else {
          this.$Notice.error({ title: '营养目标列表查询失败', desc: msg.message });
        }
      }, function (res) {
        this.myError(res.body)
      })
    },

    // 获取饮食原则
    findAllDietGuidelinesList() {
      this.$http.post('dietGuidelines/list', {
        isDeleted: false,
        pageSize: 0,
        pageNum: 0,
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.dietGuidelinesAllList = msg.data
        } else {
          this.$Notice.error({ title: '饮食原则查询失败', desc: msg.message });
        }
      }, function (res) {
        this.myError(res.body)
      })
    },
    // 关闭食谱弹窗获取制定的食谱
    getDietPlan(dietPlan) {
      if (dietPlan != null) {
        this.userDietPlan = dietPlan
      }
      this.dietPlanDialog = false
    },
    async goSave() {
      // 校验饮食原则
      if (this.prescription.dietGuidelines == null || this.prescription.dietGuidelines.length === 0) {
        this.$Notice.warning({ title: '请先选择饮食原则' })
        return
      }
      // 校验食谱
      if (this.userDietPlan == null || this.userDietPlan == {}) {
        this.$Notice.warning({ title: '请先制定食谱' })
        return
      }
      // 校验营养目标
      if (this.nutritionalGoal == null || this.nutritionalGoal.infoList == null || this.nutritionalGoal.infoList.length === 0) {
        this.$Notice.warning({ title: '请先制定营养目标' })
        return
      }
      this.$Message.loading('正在加载中。。。')
      // 保存病历
      this.saveUserDiagnose()
      // 保存随诊病历
      this.saveUserFollowDiagnose()
      // 药品/营养素
      this.saveMedicineUsage()
      // 饮食原则
      this.saveUserDietGuidelines()
      // 随诊设置
      this.saveOtherOrder()
      // 一周食谱
      this.addDietPlan()
      // 营养目标
      this.addNutritionalGoal()
      this.savePrescription()
    },
    // 保存病历
    saveUserDiagnose() {
      // 如果是首诊，用caseData存储首诊的caseData，如果是随诊，用otherCaseData存储首诊的caseData
      let caseId = null
      if (this.user.isFirst) {
        caseId = this.caseData.id
      } else {
        caseId = this.otherCaseData.id
      }
      if (caseId == null) {
        return
      }
      let temp = {}
      // 处理数据只留answer
      Object.keys(this.caseInfo).map(item => {
        if (this.caseInfo[item] != null) {
          temp[item] = this.caseInfo[item]['answer']
        }
      })
      this.$http.post('medicalRecord/updateResult', {
        id: caseId,
        result: JSON.stringify(temp),
        isAutism: this.isAutism
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
        } else {
          this.$Notice.error({ title: '保存失败', desc: msg.message });
        }
      }, function (res) {
        this.infoLoading = false
        this.myError(res.body)
      })
    },
    // 保存随诊病历
    saveUserFollowDiagnose() {
      // 如果是首诊，用otherCaseData存储随诊的caseData，如果是随诊，用caseData存储随诊的caseData
      let caseId = null
      // 如果是首诊，不用保存随诊病历
      if (this.user.isFirst) {
        return
        caseId = this.otherCaseData.id
      } else {
        caseId = this.caseData.id
      }
      if (caseId == null) {
        return
      }
      let temp = {}
      // 处理数据只留answer
      Object.keys(this.followCaseInfo).map(item => {
        if (this.followCaseInfo[item] != null) {
          temp[item] = this.followCaseInfo[item]['answer']
        }
      })
      this.$http.post('medicalRecord/updateResult', {
        id: caseId,
        result: JSON.stringify(temp),
        isAutism: this.isAutism
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
        } else {
          this.$Notice.error({ title: '保存失败', desc: msg.message });
        }
      }, function (res) {
        this.infoLoading = false
        this.myError(res.body)
      })
    },
    // 新增药品/营养素
    saveMedicineUsage() {
      let medicineUsage = {
        medicalRecordId: this.caseData.id,
        medicineUsageList: []
      }
      this.prescription.content.forEach((info) => {
        medicineUsage.medicineUsageList.push({
          medicineId: info.medicine.id,
          usage: info.frequency + info.once.num + info.once.type,
          channel: info.channel,
          day: info.dayNum,
          medicineNum: info.num,
          remark: info.content
        })
      })
      this.$http.post('medicalRecord/updateMedicineUsage',
        medicineUsage,
        { emulateJSON: false }).then(function (res) {
          let msg = res.body
          if (msg.success) {
          } else {
            this.$Notice.error({ title: '处方䇝保存失败', desc: msg.message });
          }
        }, function (res) {
          this.myError(res.body)
        })
    },
    // 新增食谱
    addDietPlan() {
      let infoList = []
      for (let i in this.userDietPlan.dietPlan) {
        infoList = infoList.concat(this.userDietPlan.dietPlan[i])
      }
      if (infoList.length === 0) {
        return this.$Message.warning('食谱不能为空')
      }
      this.$http.post('dietPlan/add', {
        userId: this.user.id,
        infoList: JSON.stringify(infoList)
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.prescription.dietPlanId = msg.data.id
          this.dietPlanId = msg.data.id
        } else {
          this.$Notice.error({ title: '食谱新增失败', desc: msg.message });
        }
      }, function (res) {
        this.cancelItem()
        this.myError(res.body)
      })
    },
    // 保存饮食原则
    saveUserDietGuidelines() {
      let temp = []
      // 处理饮食原则的禁食界限，有禁止则界限为禁止，有中等则界限为中等
      this.dietGuidelinesAllList.map(lines => {
        // 如果原则被选中，则获取禁食界限
        if (this.prescription.dietGuidelines.indexOf(lines.id) >= 0) {
          lines.detailList.map(line => {
            if (line.name === '禁止') {
              this.prescription.dietGuidelinesDetail.push(line.id)
            } else if (line.name === '中等') {
              this.prescription.dietGuidelinesDetail.push(line.id)
            }
          })
        }
      })
      this.$http.post('dietGuidelines/addUser', {
        userId: this.user.id,
        detailIds: this.prescription.dietGuidelinesDetail.toString()
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
        } else {
          this.$Notice.error({ title: '保存失败', desc: msg.message });
        }
      }, function (res) {
        this.infoLoading = false
        this.myError(res.body)
      })
    },
    // 新增饮食目标
    addNutritionalGoal() {
      this.$http.post('nutritionalGoal/add', {
        name: this.caseData.id,
        nutritionalGoalInfos: JSON.stringify(this.nutritionalGoal.infoList)
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.prescription.nutritionalGoalId = msg.data.id
          this.nutritionalGoalId = msg.data.id
        } else {
          this.$Notice.error({ title: '营养目标新增失败', desc: msg.message });
        }
      }, function (res) {
        this.myError(res.body)
      })
    },
    // 保存下次随诊时间
    saveOtherOrder() {
      if (this.prescription.followTime == null) {
        return
      }
      let orderTime = new Date(new Date(this.prescription.followTime).getTime() - parseInt(this.prescription.remindTime) * 24 * 60 * 60 * 1000)
      this.$http.post('medicalRecord/addOrder', {
        userId: this.user.id,
        medicalRecordId: this.caseData.id,
        orderTime: orderTime.toString(),
        diagnoseTime: this.prescription.followTime.toString()
      }).then(function (res) {
        let msg = res.body
        if (msg.success) {
        } else {
          this.$Notice.error({ title: '下次随诊设置失败', desc: msg.message });
        }
      }, function (res) {
        this.myError(res.body)
      })
    },
    // 新增诊断处方
    async savePrescription() {
      let examination = ''
      // 检测检查
      if (this.prescription.examination != null && this.prescription.examination.length > 0) {
        this.prescription.examination.map(item => {
          if (examination !== '') {
            examination = examination + ', '
          }
          examination = examination + item
        })
      }
      if (examination !== '' && this.prescription.otherExamination != null) {
        examination = examination + ', ' + this.prescription.otherExamination
      } else if (this.prescription.otherExamination != null) {
        examination = this.prescription.otherExamination
      }
      // 诊断
      let diagnose = ''
      if (this.prescription.diagnose != null) {
        this.userDiagnose = this.prescription.diagnose[0]
      } else if (this.prescription.otherDiagnose != null) {
        this.userDiagnose = this.prescription.otherDiagnose
      }
      // 保存医生为患者下的诊断
      await this.updateUserDiagnose()
      this.prescription.diagnose.map(item => {
        if (diagnose !== '') {
          diagnose = diagnose + ', '
        }
        diagnose = diagnose + item
      })
      if (diagnose !== '' && this.prescription.otherDiagnose != null) {
        diagnose = diagnose + ', ' + this.prescription.otherDiagnose
      } else if (this.prescription.otherDiagnose != null) {
        diagnose = this.prescription.otherDiagnose
      }
      let p = {
        userId: this.user.id,
        medicalRecordId: this.caseData.id,
        dietPlanId: this.dietPlanId,
        nutritionalGoalId: this.nutritionalGoalId,
        doctorAdvice: this.prescription.remark,
        impression: this.prescription.impression, // 体检印象
        content: diagnose, // 诊断
        examination: examination // 检测
      }
      this.$http.post('prescription/add', p, { emulateJSON: false }).then(function (res) {
        let msg = res.body
        if (msg.success) {
          this.$Notice.success({ title: '处方新增成功' });
          this.$router.push('/doctor_manage')
        } else {
          this.$Notice.error({ title: '处方新增失败', desc: msg.message });
        }
      }, function (res) {
        this.myError(res.body)
      })
    },
    // 修改患者的诊断
    updateUserDiagnose() {
      if (this.userDiagnose == null || this.userDiagnose === '') {
        return
      }
      console.log('this.userDiagnose', this.userDiagnose)
      let p = {
        id: this.user.id,
        diagnoseContent: this.userDiagnose
      }
      this.$http.post('user/update', p).then(function (res) {
        let msg = res.body
        if (msg.success) {
          //                        this.$router.push('/doctor_manage')
        } else {
          this.$Notice.error({ title: '处方新增失败', desc: msg.message });
        }
      }, function (res) {
        this.myError(res.body)
      })
    },
    // 根据生日获取年龄
    getAgeByBirthday(birthday) {
      if (!birthday) {
        return
      }
      let returnAge;
      let strBirthdayArr = birthday.split("-");
      let birthYear = strBirthdayArr[0];
      let birthMonth = strBirthdayArr[1];
      let birthDay = strBirthdayArr[2];

      let d = new Date();
      let nowYear = d.getFullYear();
      let nowMonth = d.getMonth() + 1;
      let nowDay = d.getDate();

      if (nowYear == birthYear) {
        returnAge = 0;//同年 则为0岁
      } else {
        let ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
          if (nowMonth == birthMonth) {
            let dayDiff = nowDay - birthDay;//日之差
            if (dayDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          } else {
            let monthDiff = nowMonth - birthMonth;//月之差
            if (monthDiff < 0) {
              returnAge = ageDiff - 1;
            } else {
              returnAge = ageDiff;
            }
          }
        } else {
          returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
      }

      return returnAge;//返回周岁年龄
    }
  }
}
</script>

<style scoped>
.bold-label {
  font-size: 15px;
  font-weight: bold;
}

.user-label {
  height: 21px;
}

>>>.ivu-card-head {
  padding: 6px 16px;
}

>>>td.ivu-table-expanded-cell {
  padding: 20px 10px;
}

.group-row {
  display: flex;
  flex-direction: row;
  width: 100%;
}</style>
